(function FitBuilderTemplateDaySort($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/FitBuilderTemplates/daySort/'], function onload() {
			// for day dragging
			var container = $('.fbt-days-container')[0];
			var drake     = dragula([container], {
				revertOnSpill: true,
				moves        : function dragulaMoves(el, container, handle) {
					// drag is only initialized through the header of the panel
					var $day_header = $(handle).parents('.fbt-day-header');
					return $day_header.length > 0;
				}
			});

			drake.on('drop', function onDrop(el, target, source, sibling) {
				var fit_builder_template_id = $('.fbt-days-container').data('id'),
					day_data                = {};

				// add template id to processing data
				day_data['id'] = fit_builder_template_id;

				// init days node
				day_data['days'] = {};

				// dropped the day panel to it's destination
				$('.fbt-days').each(function eachDay(i, elem) {
					// add the element's current day components value for processing
					if ($(elem).hasClass('gu-mirror') === false) {
						day_data['days'][i] = {};

						// loop through the day's components
						$(elem).find('.fbt-day-component').each(function eachDayComponent(x, compElem) {
							day_data['days'][i][x] = $(compElem).data('component_id');
						});
					}

					// update day headings and data-day attribute
					$(elem).find('.fbt-day-header h3').first().html('Day ' + (i+1));
					$(elem).attr('data-day', (i+1));
				});

				// process day sorting
				Adzuki.Ajax.post('/FitBuilderTemplates/saveDaySort/', day_data)
				.then(function success(response) {
					if (response.saved === 'true') {
						toastr.success(
							'Day sort order saved!',
							null,
							{
								positionClass  : 'toast-top-center',
								timeOut        : 5000,
								extendedTimeOut: 0,
							}
						);
					}
				});
			});

			drake.on('drag', function onDrag(el, source) {
				// hide the contents of the day while it's being dragged
				$(el).find('.fbt-day-components').addClass('hidden');
				$(el).find('h4').addClass('hidden');
			});

			drake.on('dragend', function onDragend(el) {
				// display the contents of the day back when the user stops dragging
				$(el).find('.fbt-day-components').removeClass('hidden');
				$(el).find('h4').removeClass('hidden');
			});

			// for component dragging
			$('.fbt-day-components').each(function _setDraggers(index) {
				dragula([$('.fbt-day-components')[index]], {
					revertOnSpill: true,
				})
				.on('drop', function dropIt(this_el, target, source, sibling)
				{
					handleSortOrder(index);
				});
			});

			// if there are a lot of days, scroll the page when dragging stuff up or down
			autoScroll([
				window,
				container
			], {
				margin    : 50,
				pixels    : 20,
				maxSpeed  : 20,
				autoScroll: function autoScrolling() {
					return this.down && drake.dragging;
				}
			});
		});
	});

	function handleSortOrder(index) {
		var $container = $('.fbt-day-components[data-index="' + index + '"]'),
			$children  = $container.find('.fbt-day-component'),
			data       = {};

		$children.each(function _iterateChildren(i) {
			data[i] = $(this).data('component_id');
		});

		// process component sourcing
		Adzuki.Ajax.post('/FitBuilderTemplates/saveComponentSort/', data)
		.then(function success(response) {
			if (response.saved === 'true') {
				toastr.success(
					'Component sort order saved!',
					null,
					{
						positionClass  : 'toast-top-center',
						timeOut        : 5000,
						extendedTimeOut: 0,
					}
				);
			}
		});
	}
}(jQuery, window.Adzuki || {}));
